import { FC, useMemo } from "react";
import { StatItem } from "../../../../pages/Statistics";
import { Carpool } from "../../../../types/Carpool";
import { useAuth } from "../../../../providers/useAuth";

interface Props {
  filteredCarpools?: Carpool[];
}
const CarpoolsToWork: FC<Props> = ({ filteredCarpools }): JSX.Element => {
  const { userData } = useAuth();
  const value = useMemo(
    () =>
      filteredCarpools?.filter(
        (c) => c.destination.id?.split(".")?.[0] === userData?.corporate
      ).length,
    [filteredCarpools, userData?.corporate]
  );

  return (
    <StatItem
      background="#D3E9B9"
      title="Carpools To Work"
      subTitle=""
      unit="Carpool"
      icon="car_side"
      decimalPoints={0}
      value={value}
    />
  );
};

export default CarpoolsToWork;
